/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import PropTypes from 'prop-types';
import * as consts from '../../../const';
import TcDropdownButton from './tc.dropdown.button';
import MenuItem from './menu.item.component';
import has from 'lodash/has';
import { generateIteratorKey as keygen } from '../../../utils/helpers';
import { checkUserRoles } from '../../../helper/assignment.helper';

class ReportsComponent extends React.Component {
  contextMenuOpen = false;

  constructor(props) {
    super(props);
    /**
     * @type {{updateState: string}}
     * @description set updateState on toggle to trigger render
     */
    this.state = {
      updateState: false,
      showParticipantArchive: false,
      signedConsentingsNumber: null
    };

    this.showAllSites = this.showAllSites.bind(this);
    this.onToggle = this.onToggle.bind(this);
    this.downloadActiveStudyPersonel = this.downloadActiveStudyPersonel.bind(this);
    this.downloadAccessRights = this.downloadAccessRights.bind(this);
    this.showParticipantArchiveModal = this.showParticipantArchiveModal.bind(this);
    this.showParticipantArchiveButton = this.showParticipantArchiveButton.bind(this);
  }

  componentWillUnmount() {
    this.props.clearCSV();
  }

  getDate() {
    const d = new Date();
    function z(n) {
      return (n < 10 ? '0' : '') + n;
    }
    const date = d.getFullYear() + '-' + z(d.getMonth() + 1) + '-' + z(d.getDate());
    return date;
  }

  getActiveStudyPersonelDocName() {
    const d = new Date().toJSON();
    const update = d.slice(0, -8).split('T');
    const tmp = update[0].split('-').reverse();

    tmp[1] = consts.DATE_MONTHS[parseInt(tmp[1]) - 1];
    const updatedDate = tmp.join(' ');
    const docName = ['personnel', '_', this.props.study.name, '_', updatedDate, '.csv'].join('');

    return docName;
  }

  onToggle() {
    this.contextMenuOpen = !this.contextMenuOpen;
    this.setState(() => ({ updateState: !this.state.updateState }));
  }

  showAllSites() {
    this.onToggle();
    this.props.showAllReports(this.props.sites.items.organizationsByStudy.data);
  }

  showParticipantArchiveModal() {
    this.onToggle();
    this.props.showExportParticipantArchiveMenu(this.props.study);
  }

  downloadFile(objectBlob, documentName) {
    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(objectBlob.blob, documentName);
    } else {
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(objectBlob.blob);
      link.download = documentName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  showParticipantArchiveButton() {
    if (this.props.userAssignment) {
      const studyGid = this.props.study.gid;
      if (checkUserRoles(studyGid, this.props.userAssignment) && this.props.signedConsentingsNo > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  downloadActiveStudyPersonel() {
    this.onToggle();
    this.props.downloadStudyPersonelCSV(this.props.sponsor.databasename, this.props.study.gid).then((response) => {
      if (response.payload.objectBlob) {
        const docName = this.getActiveStudyPersonelDocName();
        this.downloadFile(response.payload.objectBlob, docName);
      }
    });
  }

  downloadAccessRights() {
    this.onToggle();
    let payload = {
      studyName: this.props.study.name,
      sponsorName: this.props.sponsor.sponsorname,
      protocolNumber: this.props.study.protocolNumber
    };

    this.props.downloadAccessLogCSV(this.props.study.gid, payload).then((response) => {
      if (response.payload.objectBlob) {
        const date = this.getDate();
        const accessRightsDocName = [
          this.props.study.protocolNumber,
          '-',
          date,
          '-',
          'Access Rights Log',
          '.xlsx'
        ].join('');
        this.downloadFile(response.payload.objectBlob, accessRightsDocName);
      }
    });
  }

  render() {
    const {
      sites,
      study: { permissions }
    } = this.props;
    let items = [];
    if (has(sites, 'items.organizationsByStudy.data') && sites.items.organizationsByStudy.data.length > 0) {
      items.push(
        <MenuItem
          {...keygen()}
          tcStyle="report-item"
          tcLabel={consts.ANSWERS_TO_OPT_IN}
          tcDownloadHandler={this.showAllSites}
        />
      );
    }
    if (this.showParticipantArchiveButton()) {
      items.push(
        <MenuItem
          {...keygen()}
          tcStyle={`report-item ${this.props.isExportInitiated ? 'disabled' : ''}`}
          tcLabel={consts.PARTICIPANT_ARCHIVE}
          tcDownloadHandler={this.showParticipantArchiveModal}
        />
      );
    }

    items.push(
      <MenuItem
        {...keygen()}
        tcStyle="report-item"
        tcLabel={consts.ACTIVE_STUDY_PERSONEL}
        tcDownloadHandler={this.downloadActiveStudyPersonel}
      />
    );
    items.push(
      <MenuItem
        {...keygen()}
        tcStyle="report-item"
        tcLabel={consts.ACCESS_RIGHTS_HISTORY}
        tcDownloadHandler={this.downloadAccessRights}
      />
    );

    return (
      <div id="reports-component">
        <TcDropdownButton
          id="reports-dropdown"
          tcStyle={{ headerStyle: 'reports-header', bodyStyle: 'reports-sites', footerStyle: 'reports-footer' }}
          open={this.contextMenuOpen}
          tcToggleWrapper={this.state.updateState}
          onClick={this.onToggle}
          title={consts.EXPORT_DATA}
        >
          {items}
        </TcDropdownButton>
      </div>
    );
  }
}

ReportsComponent.propTypes = {
  study: PropTypes.object,
  sites: PropTypes.object,
  userAssignment: PropTypes.array,
  objectBlobReports: PropTypes.object,
  objectBlobAccessRights: PropTypes.object,
  objectBlobActivePersonel: PropTypes.object,
  isExportInitiated: PropTypes.bool,
  signedConsentingsNo: PropTypes.number
};

export default ReportsComponent;
